import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'BigQueryIntegration',
  data () {
    return {
      isLoading: {
        integrations: false,
        save: false,
        test: false,
        delete: false
      },
      settings: {
        projectId: '',
        datasetId: ''
      },
      testResult: null,
      errorMessage: ''
    }
  },
  computed: {
    ...mapGetters([
      'bigQueryIntegration'
    ]),
    contentplanId () {
      return parseInt(this.$route.params.contentplanId)
    },
    workspaceId () {
      return parseInt(this.$route.params.workspaceId)
    },
    hasIntegration () {
      return !!this.bigQueryIntegration?.bq_project_id
    },
    isValid () {
      return Boolean(this.settings.projectId && this.settings.datasetId)
    }
  },
  methods: {
    ...mapActions([
      'saveBigQueryConfig',
      'getIntegrations',
      'deleteIntegration'
    ]),
    ...mapMutations([
      'setSnackbar'
    ]),
    fillValues () {
      const integration = this.bigQueryIntegration
      if (!integration) return
      this.settings.projectId = integration.bq_project_id || ''
      this.settings.datasetId = integration.bq_dataset_id || ''
    },
    async handleTest () {
      if (!this.isValid) {
        this.errorMessage = 'Project ID and dataset ID are required.'
        return
      }

      this.isLoading.test = true
      this.errorMessage = ''
      this.testResult = null
      try {
        const response = await this.saveBigQueryConfig({
          contentplanId: this.contentplanId,
          projectId: this.settings.projectId,
          datasetId: this.settings.datasetId,
          action: 'test'
        })
        if (response?.success === false) {
          this.errorMessage = response?.error || 'BigQuery connection failed.'
          this.testResult = null
        } else {
          this.testResult = response
        }
      } catch (error) {
        this.errorMessage = error?.response?.data?.message || error.message || 'Failed to test BigQuery connection.'
      } finally {
        this.isLoading.test = false
      }
    },
    async handleSave () {
      if (!this.isValid) {
        this.errorMessage = 'Project ID and dataset ID are required.'
        return
      }

      this.isLoading.save = true
      this.errorMessage = ''
      try {
        await this.saveBigQueryConfig({
          contentplanId: this.contentplanId,
          projectId: this.settings.projectId,
          datasetId: this.settings.datasetId
        })
        this.setSnackbar({ open: true, text: 'BigQuery configuration saved.', type: 'success' })
        this.$router.push({
          name: 'ContentplanSettings',
          params: { contentplanId: this.contentplanId, workspaceId: this.workspaceId }
        })
      } catch (error) {
        this.errorMessage = error?.response?.data?.message || error.message || 'Failed to save BigQuery configuration.'
      } finally {
        this.isLoading.save = false
      }
    },
    async handleDelete () {
      if (!this.hasIntegration) return
      if (this.isLoading.delete) return
      if (!window.confirm('are you sure you want to remove integration')) return

      this.isLoading.delete = true
      try {
        await this.deleteIntegration({
          contentplanId: this.contentplanId,
          integrationType: 'bigquery'
        })
        await this.getIntegrations({ contentplanId: this.contentplanId })
        this.setSnackbar({ open: true, text: 'Integration removed.', type: 'success' })
        this.$router.push({
          name: 'ContentplanSettings',
          params: { contentplanId: this.contentplanId, workspaceId: this.workspaceId }
        })
      } catch (error) {
        this.setSnackbar({ open: true, text: `Error: ${error?.response?.data?.message || error.message || 'Could not remove integration'}`, type: 'error' })
      } finally {
        this.isLoading.delete = false
      }
    }
  },
  async mounted () {
    this.isLoading.integrations = true
    try {
      await this.getIntegrations({ contentplanId: this.contentplanId })
      this.fillValues()
    } catch (error) {
      console.error(error)
    }
    this.isLoading.integrations = false
  }
}
